import {
  GETALL_SUBAREAS,
  LOADING_GETALL_SUBAREAS,
  ACTIVO_SUBAREAS,
  SET_LOGOUT,
  PARAMS_SUBAREAS,
} from '../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  meta: null,
  links: null,
  activo: null,
  params: {},
};

export const subareasReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_SUBAREAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_SUBAREAS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_SUBAREAS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_SUBAREAS:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
